// extracted by mini-css-extract-plugin
module.exports = {"blocks":"Make1099Mistakes_blocks__x2N7h"};